import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import InsightDetail from "@/pages/InsightDetail";
import CaseStudies from "@/pages/CaseStudies";
import Piattaforma from "@/pages/Piattaforma";
import Valutazione from "@/pages/Valutazione";
import SimulatoreSostenibilita from "@/pages/SimulatoreSostenibilita";
import Marketplace from "@/pages/Marketplace";
import { Partner, Academy } from "@/pages/ApplicationPages";
import Osservatorio from "@/pages/Osservatorio";
import RegistroPromesse from "@/pages/RegistroPromesse";
import StandardAgreement from "@/pages/StandardAgreement";
import Prezzi from "@/pages/Prezzi";
import Metodo from "@/pages/Metodo";
import ChiSiamo from "@/pages/ChiSiamo";
import Privacy from "@/pages/Privacy";
import LandingRegionale from "@/pages/LandingRegionale";
import InsightsIndex from "@/pages/InsightsIndex";
import CookieBanner from "@/components/CookieBanner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/ProtectedRoute";

function PublicShell({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/piattaforma" element={<PublicShell><Piattaforma /></PublicShell>} />
            <Route path="/valutazione" element={<PublicShell><Valutazione /></PublicShell>} />
            <Route path="/simulatore-sostenibilita" element={<PublicShell><SimulatoreSostenibilita /></PublicShell>} />
            <Route path="/marketplace" element={<PublicShell><Marketplace /></PublicShell>} />
            <Route path="/partner" element={<PublicShell><Partner /></PublicShell>} />
            <Route path="/academy" element={<PublicShell><Academy /></PublicShell>} />
            <Route path="/osservatorio" element={<PublicShell><Osservatorio /></PublicShell>} />
            <Route path="/registro-promesse" element={<PublicShell><RegistroPromesse /></PublicShell>} />
            <Route path="/standard-agreement" element={<PublicShell><StandardAgreement /></PublicShell>} />
            <Route path="/prezzi" element={<PublicShell><Prezzi /></PublicShell>} />
            <Route path="/metodo" element={<PublicShell><Metodo /></PublicShell>} />
            <Route path="/chi-siamo" element={<PublicShell><ChiSiamo /></PublicShell>} />
            <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
            <Route path="/vendere-azienda/:region" element={<PublicShell><LandingRegionale /></PublicShell>} />
            <Route path="/insights" element={<PublicShell><InsightsIndex /></PublicShell>} />
            <Route path="/case-studies" element={<PublicShell><CaseStudies /></PublicShell>} />
            <Route path="/insights/:slug" element={<PublicShell><InsightDetail /></PublicShell>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
